module.exports = __webpack_public_path__ + "img/k03.dbcd9337.png";